import { render, staticRenderFns } from "./settleAccountRecord.vue?vue&type=template&id=27631bda&scoped=true"
import script from "./settleAccountRecord.vue?vue&type=script&lang=js"
export * from "./settleAccountRecord.vue?vue&type=script&lang=js"
import style0 from "./settleAccountRecord.vue?vue&type=style&index=0&id=27631bda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27631bda",
  null
  
)

export default component.exports